import axios from "../Config/index";

const SsoB3Route = {
  // ================ Users ================ //
  // PutInvitation: (data) => axios.put("/invitation", data),
  // GetComment: () => axios.get("/comment"),
  OrganizationUsers: (orgUuid, param) =>
    axios.get("/service-users/users/all/organization/" + orgUuid, {
      params: param,
    }),
  Organization: (userId, param) =>
    axios.get("/service-users/users/organization/all/" + userId, {
      params: param,
      sessionToken: localStorage.getItem("sessionToken"),
    }),
  Login: (data) => axios.post("/service-users/users/auth/login/b3", data),
  Otp: (data) => axios.post("/service-users/users/auth/tfa/b3", data),
  VerifySession: () => axios.get("/b3/_a/auth/private/v2/sessiontokens"),
  Logout: () => axios.post("/b3/_a/auth/private/v2/logout"),
};
export default SsoB3Route;
